export default "__VITE_ASSET__f9bc82aa__"